import React, { useContext } from "react";
import "./sideBar.scss";
import { MdOutlineLogout } from "react-icons/md";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import { TiHome } from "react-icons/ti";
import { FaUser } from "react-icons/fa";
import { GrAnnounce } from "react-icons/gr";
import { FaRegSquarePlus } from "react-icons/fa6";
import { FiMessageSquare } from "react-icons/fi";
import { MdUpdate } from "react-icons/md";


const SideBar = () => {
  const navigate = useNavigate();
  const { admin, dispatch } = useContext(AuthContext);

  const user = admin.role === "admin";

  const logoutUser = async () => {
    const controller = new AbortController();
    const signal = controller.signal;
    try {
      await axios.get("/admin-logout");
      localStorage.removeItem("admin");
      dispatch({ type: "LOGOUT" });
      navigate("/");
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("Request canceled", error.message);
      } else {
        console.error("Error fetching data:", error);
      }
    }
    return () => controller.abort();
  };
  return (
    <div className="sideBar_wrp">
      <div className="sideBar_in">
        <Link to={"/inquiry"}>
          <div className="sideBar_top">
            <img src={require("../../img/logo.png")} alt="" />
          </div>
        </Link>
        <div className="sideBar_center">
          <ul>
            <NavLink
              to="/inquiry"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <li>
                <TiHome size={16} /> <small>Inquiry</small>
              </li>
            </NavLink>
            <NavLink
              to="/add-update"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <li>
                <FaRegSquarePlus size={13} /> <small>Update</small>
              </li>
            </NavLink>
          </ul>
        </div>
        <div className="sideBar_bottom">
          {/* <span>
            <IoSettingsOutline />
          </span> */}
          <span onClick={logoutUser}>
            <MdOutlineLogout fontSize={20} />
            <small>Logout</small>
          </span>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
